/**
 * A query string da ENTRADA, capturada na avaliação do módulo.
 *
 * Ler `window.location.search` dentro de um efeito do `_app` chega tarde: efeito é passivo e só
 * corre depois da pintura, e um clique num link já hidratado nessa janela executa o `pushState`,
 * que é síncrono. Ali `location` já é o DESTINO — os parâmetros da entrada somem antes de qualquer
 * um lê-los, e quem chegou por anúncio vira "sem origem".
 *
 * A avaliação do módulo acontece no carregamento do bundle, antes da hidratação, então o valor aqui
 * é sempre o da URL que a pessoa realmente abriu.
 *
 * É o mesmo motivo, e a mesma solução, do `entryLocation` em `utils/googleAnalytics.ts`. Vive num
 * módulo próprio porque dois leitores diferentes precisam do MESMO instantâneo — a origem de
 * aquisição e o código de indicação, ambos lidos na entrada pelo `_app`.
 */
export const ENTRY_SEARCH =
  typeof window === 'undefined' ? '' : window.location.search;
